import createPersistedState from 'vuex-persistedstate'

export const authPersist = createPersistedState({
  paths: ['auth', 'frontend', 'localization']
})


